// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__yxX2W","subheader":"ReorderModal_subheader__3OStO","listWrap":"ReorderModal_listWrap__12B4C"};